import { useMutation } from '@tanstack/react-query';
import { api } from 'src/services';

type OnboardPractitionerPayload = {
  org_name: string;
  specialities: [string];
  ehr_system: string;
  referral_source: string;
  referral_code?: string;
};

export type OnboardPractitionerResponse = unknown;

export const useOnboardPractitioner = () => {
  return useMutation({
    mutationKey: ['onboardPractitioner'],
    mutationFn: (payload: OnboardPractitionerPayload) =>
      api.post<OnboardPractitionerResponse>('/onboarding', payload),
  });
};
